import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import VizExImage from 'visitor-ui-component-library/image/VizExImage';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const InlineImageAttachmentWrapper = styled.div.withConfig({
  displayName: "InlineImageAttachment__InlineImageAttachmentWrapper"
})(["display:block;max-width:100%;"]);
export const getDimensions = ({
  maxWidth,
  width,
  height,
  hasLoaded
}) => {
  if (hasLoaded || !maxWidth || !width || !height) {
    return {};
  }
  if (width <= maxWidth) {
    return {
      width,
      height
    };
  }
  const scale = maxWidth / width;
  return {
    width: maxWidth,
    height: height * scale
  };
};
class InlineImageAttachment extends PureComponent {
  constructor(props) {
    super(props);
    this.hasLoadedImage = () => {
      this.setState({
        hasLoaded: true
      });
    };
    this.state = {
      hasLoaded: false
    };
  }
  render() {
    const {
      name,
      url
    } = this.props;
    const {
      width,
      height
    } = getDimensions(Object.assign({}, this.props, this.state));
    return /*#__PURE__*/_jsx(InlineImageAttachmentWrapper, {
      children: /*#__PURE__*/_jsx(VizExLink, {
        href: url,
        target: "_blank",
        "data-test-id": "inline-image-attachment",
        children: /*#__PURE__*/_jsx(VizExImage, {
          alt: name,
          src: url,
          width: width,
          height: height,
          style: {
            minHeight: height
          },
          onLoad: this.hasLoadedImage
        })
      })
    });
  }
}
InlineImageAttachment.displayName = 'InlineImageAttachment';
InlineImageAttachment.propTypes = {
  height: PropTypes.number,
  maxWidth: PropTypes.number,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  width: PropTypes.number
};
export default InlineImageAttachment;